import { getStatistics } from 'sagas/firebase'
import { call, takeLatest } from 'redux-saga/effects'

export function* checkIfStatisticsShouldBeDownloaded() {
  // Get statistics in every case
  yield call(getStatistics)
}

export function* checkforStatisticsDownloadAfterRehydration() {
  yield takeLatest('persist/REHYDRATE', checkIfStatisticsShouldBeDownloaded)
}
